const UserRead = () => import('@/views/UserRead')

export default [
  {
    path: '/userRead',
    component: UserRead,
    meta: { requireAuth: true }
  }
]
